export default "__VITE_ASSET__yhluEG6v__"